import React, {useEffect, useState} from 'react';
import {Button, CircularProgress, Input, Pagination} from "@nextui-org/react";
import {Box} from "@mui/material";
import axios from "axios";
import {CardComponent} from "./card.component";
import {Search} from "@mui/icons-material";
import {useLocation, useNavigate} from "react-router-dom";

export default function FavComponent(props) {

    const [localLikes, setLocalLikes] = useState([]);

    function fetchLocalLikes() {
        const items = JSON.parse(localStorage.getItem('local_likes'));
        if (items) {
            setLocalLikes(items);
        }
    }

    const navigate = useNavigate();

    useEffect(() => {
        fetchLocalLikes();
        console.log(localLikes);
    }, []);


    return (
        localLikes.length == 0 ?
            <div className={'h-screen w-screen flex flex-col justify-center mx-auto items-center'}>
                <div style={{height: 200, width: 200}}>
                    <img alt={"No Fav Image"} src={require("../assets/img_1.png")}/>
                </div>
                <h1 className={'text-2xl md:text-4xl font-bold md:ml-20 mt-10'}>No Favorite Skin Found</h1>
                <Button variant={'ghost'} className={'mt-10'} color={'success'} onClick={() => {
                    navigate("/skins");
                }}>
                    Explore Latest Skins Now
                </Button>
            </div> : <Box className={'overflow-hidden'}>


                <div className={'px-4 sm:px-10 md:px-12 grid md:grid-cols-2 grid-cols-1'}>
                    <div className={'items-center flex'}>
                        <p className={'text-2xl md:text-4xl font-bold md:ml-20 mb-3'}>{
                            "Favorite"
                        }</p>
                    </div>
                    <div className={'xl:mr-10 xl:justify-end justify-center items-center flex'}>
                        <Input
                            classNames={{
                                base: "w-full md:w-2/3",
                                mainWrapper: "h-full",
                                input: "text-small",
                                inputWrapper: "h-full font-normal text-default-500 bg-default-400/20 dark:bg-default-500/20",
                            }}
                            placeholder="search your skins"
                            size="md"
                            startContent={<Search size={18}/>}
                            type="search"
                        />
                    </div>
                </div>
                {
                    localLikes === null ? <div className={'h-screen w-screen flex justify-center mx-auto'}>
                        <CircularProgress aria-label="Loading..."/>
                    </div> : <div
                        key={'grid_container'}
                        className="py-5 sm:py-0 px-4 sm:px-10 md:px-20 w-full gap-3 grid xl:grid-cols-6 lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-3 grid-cols-2 sm:pt-10">
                        {localLikes.map((item, index) => <div key={`CarHolder_${index}`}>
                            <CardComponent key={index} props={
                                {
                                    "item": item,
                                    "isCape": item.isCape ?? false,
                                    "index": index
                                }
                            }/>
                        </div>)}
                    </div>

                }
            </Box>
    );
}

